export const solutions = {
  it: {
    anchors: {
      hero: "Hero",
      overview: "Panoramica",
      promise: "Promessa",
      novita: "Novità 2025",
      plans: "Piani",
      value: "Valore",
      stack: "Stack Tecnologico",
      how: "Come funziona",
      why: "Perché funziona",
      ctaMid: "Check-up",
      faq: "FAQ",
      method: "Tempi & Metodo",
      legal: "Note Legali",
      ctaFinal: "CTA finale",
    },
    meta: {
      pageName: "Soluzioni",
      seoTitle: "Soluzioni — IT-as-a-Service per PMI",
      seoDescription:
        "Implementazione, integrazioni e gestione operativa per acquisizione clienti e processi digitali. Tutti i sistemi in UE (Azure + Supabase). Pronti in 14 giorni.",
    },
    value: {
      title: "Valore per il management",
      systemic: {
        title: "Comprensione sistemica",
        items: [
          "Visibilità: Google / social",
          "Reattività: automazione WhatsApp",
          "Tracciamento: CRM + Supabase",
          "Pianificazione: Bookings / Calendly",
          "Misurazione: Dashboard / BI",
          "Ottimizzazione continua: Audit + AI"
        ],
        subtitle: "Ciò che migliora davvero: KPI interni — velocità, coerenza, visibilità, proprietà del dato, prevedibilità."
      },
      impact: {
        title: "Mappa KPI & Impatto",
        headers: ["Dimensione", "KPI", "Prima (PMI)", "Dopo (Sistema)", "Impatto"],
        rows: [
          ["Velocità risposta", "Tempo medio prima risposta", "4–12h (manuale)", "< 60s (WhatsApp)", "−95% ritardo, +3× conversione"],
          ["Raccolta lead", "% contatti registrati", "40–60%", "100% nel CRM", "+60% capture"],
          ["Conversione", "% → appuntamento", "10–15%", "25–35%", "+2–3×"],
          ["No‑show", "% appuntamenti persi", "25–30%", "<10%", "−65%"],
          ["Follow‑up", "% ricontattati <48h", "<20%", ">90% (n8n)", "+70%"],
          ["Data ownership", "% dati centralizzati", "Frammentati", "100% in UE (Supabase)", "Compliance"],
          ["ROI marketing", "Costo per lead", "Non tracciato", "−30–50% vs baseline", "↓ costo"],
          ["Soddisfazione", "Rating medio Google", "3.8–4.0", "4.6+", "+15–20%"],
          ["Controllo", "Accesso KPI", "Nessuno", "Dashboard live", "+100% chiarezza"],
          ["Tempo admin", "Ore/settimana", "5–10h", "<1h", "−80–90%"],
          ["Scalabilità", "Replicabilità sedi", "Manuale", "100% replicabile", "Scalabile"],
        ]
      },
      clusters: {
        title: "Cluster KPI (Livello Executive)",
        groups: [
          { title: "Acquisizione", items: ["Lead/settimana", "Conversione a appuntamento (%)", "Costo per lead (CPL)", "Tempo alla prima risposta (s)"] },
          { title: "Operatività", items: ["Appuntamenti confermati auto (%)", "No‑show (%)", "Follow‑up (%)", "Lead → cliente (%)"] },
          { title: "Esperienza", items: ["Richieste recensione (%)", "Rating medio", "Tasso risposta clienti (%)"] },
          { title: "Sistema", items: ["Uptime automazioni (%)", "Task entro SLA (%)", "Integrità sincronizzazioni (%)", "Rating GDPR"] },
          { title: "Crescita (DOMINATE)", items: ["Accuratezza previsioni (%)", "Ricavi per campagna (€)", "ROI canale (%)", "Scoring predittivo (AUC)"] },
        ]
      },
      exec: {
        title: "Sintesi Executive",
        headers: ["Area", "Metrica chiave", "Miglioramento", "Motore"],
        rows: [
          ["Lead Management", "+60% lead salvati", "Automation via CRM", "Automazioni"],
          ["Conversione", "+220% appuntamenti", "Smart reminders", "Calendario + WhatsApp"],
          ["Customer Experience", "+0.8★ rating Google", "Auto review system", "Flussi post-servizio"],
          ["Admin Overhead", "−80% tempo", "Automations + dashboard", "Riduzione attività manuali"],
          ["ROI Visibility", "+100% tracciabilità", "Unified BI dashboard", "Tracking + BI"],
          ["Compliance", "100% dati in UE", "Azure + Supabase", "Data governance"],
        ]
      },
      narrative: {
        title: "Narrativa Strategica",
        text:
          "Adottare questo sistema trasforma una piccola impresa in un organismo digitale auto‑operante: ogni richiesta riceve risposta in secondi, ogni contatto viene salvato e ogni azione è misurata. Dal caos al flusso: visibilità → interazione → prenotazione → dato → insight. L’imprenditore ottiene il super‑potere di sapere cosa funziona, cosa no e perché."
      }
    },
    cta: {
      book: "Prenota il Check-up",
    },
    hero: {
      title: "Soluzioni — IT-as-a-Service per PMI",
      subtitle:
        "Implementazione, integrazioni e gestione operativa per acquisizione clienti e processi digitali. Ogni piano include sito, CRM, automazioni, comunicazione digitale e assistenza.",
      microProof: "Tutti i sistemi sono ospitati in UE (Azure + Supabase) e pronti all’uso in 14 giorni.",
    },
    novita: {
      title: "Novità 2025 — Comunicazione Digitale Integrata",
      atecoNote:
        "Tutto resta perfettamente compatibile con il codice ATECO 62.20.10, perché parliamo di integrazione di sistemi di comunicazione digitale, non marketing puro.",
      intro1:
        "Per offrire una presenza online realmente completa, ogni sistema ora include anche la gestione tecnica e automatizzata dei canali social.",
      intro2:
        "Questa funzione è parte integrante della consulenza informatica (ATECO 62.20.10) e collega i canali di comunicazione alla tua infrastruttura IT.",
      includesTitle: "Cosa comprende:",
      includes: [
        "Creazione e configurazione profili Facebook, Instagram e WhatsApp Business",
        "Collegamento diretto tra sito, CRM e canali social",
        "Pubblicazione e programmazione automatica dei post (tramite strumenti integrati)",
        "Setup e gestione tecnica delle campagne pubblicitarie Meta Ads e Google Ads (budget escluso)",
        "Monitoraggio dei risultati tramite dashboard unificata (Supabase + GA4 + Meta Pixel)",
        "Report mensile con copertura, contatti e tasso di risposta",
      ],
      finalitaTitle: "Finalità:",
      finalitaText:
        "Trasformare i canali social in un’estensione del sistema informatico aziendale — misurabile, tracciabile e automatizzato.",
    },
    promise: {
      headline:
        "Costruiamo e gestiamo un sistema completo: ti trovano online, ricevono risposta subito su WhatsApp, prenotano (da GROW) e tu misuri tutto in una dashboard chiara.",
      guaranteeTitle: "Garanzia",
      guarantee:
        "Definiamo insieme obiettivi realistici per il tuo settore e la tua area geografica. Se in un mese non li raggiungiamo, il mese successivo è gratuito.",
    },
    overview: {
      title: "Panoramica piani",
      viewPlan: "Vai al piano",
      clientFlowTitle: "Flusso Cliente"
    },
    plans: {
      outcomesTitle: "Risultati",
      includesTitle: "Componenti tecniche incluse",
      automationsTitle: "Automazioni (n8n)",
      goalTitle: "Obiettivo",
      adminTitle: "Ore di amministrazione incluse",
      items: [
        {
          code: "launch",
          name: "LAUNCH — Presenza Digitale Autonoma",
          price: "€390/mese",
          for: "Professionisti e PMI che vogliono essere trovati e catturare ogni contatto senza perdere tempo.",
          goal: "Essere online in 14 giorni, rispondere subito su WhatsApp e non perdere nessun potenziale cliente.",
          adminHours: "5 ore/mese",
          outcomes: [
            "Online in 14 giorni.",
            "Risposta automatica 24/7.",
            "Tutti i contatti salvati e tracciati.",
            "Nessun lead perso.",
          ],
          includes: [
            "Sito Web Vetrina: 4 sezioni (Home, Servizi, Preventivo, Contatti) su React/Vite, ospitato su Azure Static Web Apps. SEO e mobile first.",
            "Profilo Google Business: setup e ottimizzazione (categorie, servizi, orari, foto, messaggi).",
            "Gestione WhatsApp: collegamento al profilo aziendale, autoresponder 24/7 con domande di qualificazione.",
            "CRM Lite (Supabase): raccolta automatica contatti con nome, numero, richiesta, data e stato.",
            "Richiesta Recensioni Automatica: messaggio WhatsApp post-servizio con link Google.",
            "Report Mensile: riepilogo richieste, tempi risposta e canali più efficaci.",
            "Assistenza e Manutenzione: hosting gestito, sicurezza base, aggiornamenti. SLA 48h.",
          ],
          automations: [
            "Ricezione messaggi → inserimento automatico in CRM.",
            "Notifica immediata via email/WhatsApp/Telegram al titolare.",
            "Promemoria automatico se il cliente non risponde entro 15 min / 24h.",
          ],
          commsTitle: "Novità Comunicazione Digitale",
          comms: [
            "Creazione e collegamento profili Facebook e Instagram",
            "Integrazione WhatsApp Business con sito e CRM",
          ],
          shortBullets: [
            "Online in 14 giorni",
            "Risposta 24/7",
            "Contatti salvati",
            "Google Business ottimizzato",
            "Recensioni automatiche",
            "Report mensile",
          ],
        },
        {
          code: "grow",
          name: "GROW — Acquisizione Clienti Automatica",
          price: "€850/mese",
          for: "Aziende che vogliono aumentare appuntamenti e avere un flusso clienti che lavora da solo.",
          goal: "Più appuntamenti fissati, meno no-show, chiarezza sui numeri e tracciamento completo.",
          adminHours: "8 ore/mese",
          outcomes: [
            "Più appuntamenti confermati via WhatsApp.",
            "Meno appuntamenti mancati.",
            "Costi per lead e per appuntamento sempre visibili.",
            "Obiettivi chiari, garantiti.",
          ],
          includes: [
            "Tutti i moduli del piano LAUNCH",
            "Agenda Automatica: integrazione Calendly/Google Calendar con conferme e promemoria via WhatsApp.",
            "Recupero conversazioni: follow-up automatico su messaggi non letti/non gestiti.",
            "CRM Completo (Supabase): pipeline lead, tag, promemoria, note, storico conversazioni.",
            "Gestione ADV: setup + ottimizzazione di 2 campagne Google Ads o Meta Ads (budget escluso).",
            "Tracciamenti Avanzati: GA4, Tag Manager e Meta Pixel per monitoraggio lead.",
            "Report Obiettivi + Garanzia: confronto mese su mese e garanzia risultati.",
            "Assistenza Prioritaria: SLA 24h.",
          ],
          automations: [
            "Messaggi WhatsApp → CRM → Microsoft Bookings.",
            "Promemoria WhatsApp automatici 2h prima dell’appuntamento.",
            "Follow-up post-appuntamento con richiesta recensione.",
          ],
          commsTitle: "Comunicazione Digitale Avanzata",
          comms: [
            "Pianificazione automatica dei post social con modelli grafici forniti",
            "Gestione tecnica delle campagne pubblicitarie (Meta / Google)",
            "Tracciamento lead da social",
          ],
          shortBullets: [
            "Agenda automatica",
            "Recupero conversazioni",
            "2 campagne gestite (ADV esclusa)",
            "Pipeline completa",
            "Tracciamenti avanzati",
            "Report con obiettivi",
            "Garanzia risultati",
          ],
        },
        {
          code: "dominate",
          name: "DOMINATE — Intelligenza Predittiva & Scalabilità Totale",
          price: "€1.400/mese",
          for: "Realtà con più sedi o volumi elevati che vogliono previsioni, controllo e crescita continua.",
          goal: "Gestire i flussi clienti su più canali, prevedere la domanda e ottimizzare le decisioni con dashboard avanzate.",
          adminHours: "12 ore/mese",
          outcomes: [
            "Dashboard KPI e previsioni su domanda.",
            "Controllo totale su sedi, costi e performance.",
            "Ottimizzazioni continue con audit trimestrali.",
          ],
          includes: [
            "Tutti i moduli del piano GROW",
            "Dashboard BI (Business Intelligence): KPI su Supabase BI + React.",
            "Analisi Predittiva AI: modelli per domanda, orari ottimali e rischio no-show.",
            "Multi-sede / Multi-utente: gestione utenti e report per sede/team.",
            "Integrazioni Gestionali: Danea, Zucchetti, Fatture in Cloud o CRM esistenti.",
            "Audit Trimestrale: revisione tecnica e strategica con suggerimenti.",
            "SLA Prioritario 12h",
          ],
          automations: [
            "Raccolta dati multi-cliente → modelli predittivi → dashboard aggiornata.",
            "Notifiche automatiche quando superi o scendi sotto i KPI definiti.",
          ],
          commsTitle: "Comunicazione Digitale Avanzata",
          comms: [
            "Dashboard BI con dati da Google Ads, Meta Ads e CRM",
            "Analisi predittiva delle performance pubblicitarie",
            "Revisione trimestrale della strategia digitale",
          ],
          shortBullets: [
            "Dashboard KPI & previsioni",
            "Multi-sede",
            "Integrazioni gestionali",
            "Audit trimestrale",
            "Priorità interventi",
            "SLA 12h",
          ],
        },
      ],
    },
    stack: {
      title: "Stack Tecnologico",
      items: [
        "Frontend: React + Vite",
        "Backend: Supabase (DB, Auth, Storage)",
        "Automazioni: n8n (Azure VM o Cloud)",
        "Hosting: Azure App Service / Static Web Apps",
        "Tracking: GA4, Tag Manager, Meta Pixel",
        "Messaging: WhatsApp Business (account del Cliente)",
      ],
    },
    how: {
      steps: [
        { title: "Ti trovano", text: "Google Business + sito ottimizzato + WhatsApp visibile" },
        { title: "Rispondono subito", text: "Automazione 24/7 raccoglie nome, richiesta, zona" },
        { title: "Prenotano (da GROW)", text: "Calendario automatico e conferma appuntamento" },
        { title: "Misuri", text: "Dashboard con contatti, appuntamenti e risultati" },
      ],
    },
    diagram: {
      common: {
        inputs: {
          website: "Sito Web",
          whatsapp: "WhatsApp",
          ads: "Google/Meta Ads",
        },
      },
      launch: {
        title: "Automazione WhatsApp",
        bullets: ["Qualificazione", "Risposte 24/7", "Notifiche"],
        outputs: {
          crm: "CRM Lite",
        },
      },
      grow: {
        title: "Automazione → Appuntamento",
        bullets: ["Agenda automatica", "Promemoria", "Follow-up"],
        outputs: {
          calendar: "Calendario",
          crm: "CRM Completo",
        },
      },
      dominate: {
        title: "Automazioni + Predittivo",
        bullets: ["Integrazioni", "Modelli AI", "Alert KPI"],
        outputs: {
          bi: "Dashboard BI",
          crm: "CRM",
          
        },
      },
    },
    preview: {
      common: {
        headerBrand: "Victor Lazari",
        nav: {
          home: "Home",
          leads: "Leads",
          whatsapp: "WhatsApp",
          reports: "Report",
          settings: "Impostazioni"
        },
        filters: {
          whatsapp: "WhatsApp",
          status: "Stato",
          statusInProgress: "In corso"
        },
        panels: {
          crm: "CRM",
          calendar: "Calendario",
          adv: "Campagne ADV"
        },
        table: {
          name: "Nome",
          phone: "Telefono",
          channel: "Canale",
          status: "Stato",
          last: "Ultima attività",
          location: "Sede"
        },
        widgets: {
          total: "Contatti totali mese",
          avgResponse: "Tempo medio risposta",
          followup: "Tasso follow‑up WhatsApp",
          trend: "Andamento settimanale",
          revenue: "Ricavi stimati",
          channelMix: "Mix canali",
          funnel: "Funnel",
          leads: "Lead",
          appointments: "Appuntamenti",
          conversion: "Conversione",
          byLocation: "Per sede"
        },
        actions: {
          newLead: "Nuovo lead",
          export: "Esporta",
          calendar: "Calendario",
          location: "Sede",
          adv: "ADV"
        },
        daysShort: ["L", "M", "M", "G", "V", "S", "D"],
        campaigns: {
          title: "Campagne",
          budget: "Budget giornaliero",
          cpa: "CPA",
          leads: "Lead mese",
          status: {
            active: "Attiva",
            paused: "In pausa"
          }
        },
        notif: "Notifiche",
        toast: "Nuovo lead da WhatsApp salvato nel CRM",
        powered: "Powered by Supabase + Azure"
        ,
        rows: [
          { name: "Giulia R.", phone: "+39 333 214 9982", channel: "WhatsApp", status: { code: "in_progress", label: "In corso" }, last: "5 min fa" },
          { name: "Andrea C.", phone: "+39 392 775 5420", channel: "Web Form", status: { code: "new", label: "Nuovo" }, last: "14 min fa" },
          { name: "Officina Morelli", phone: "+39 345 228 9012", channel: "Google Ads", status: { code: "closed", label: "Chiuso" }, last: "ieri" }
        ]
      },
      header: {
        launch: "Sistema attivo del piano LAUNCH — gestione contatti e messaggi automatizzata (Supabase + Azure)",
        grow: "Sistema attivo del piano GROW — appuntamenti automatici e campagne gestite (Supabase + Azure)",
        dominate: "Sistema attivo del piano DOMINATE — BI, multi‑sede e analisi predittiva (Supabase + Azure)"
      },
      demoIntro: {
        title: "Demo live — Gestione automatica dei contatti (CRM integrato)",
        body:
          "Questa è la dashboard del sistema: i messaggi da sito, WhatsApp e Google vengono raccolti qui in tempo reale. Da qui puoi vedere, rispondere e misurare le performance mensili.",
        bodyByTier: {
          launch: "Questa è la dashboard che ricevi con il piano LAUNCH: tutti i messaggi da sito, WhatsApp e Google vengono raccolti qui in tempo reale. Da qui puoi vedere, rispondere e misurare le performance mensili.",
          grow: "Questa è la dashboard del piano GROW: messaggi da sito/WhatsApp/Google con calendario automatico e CRM. Qui gestisci appuntamenti, conversazioni e risultati.",
          dominate: "Questa è la dashboard del piano DOMINATE: messaggi, calendario e KPI con BI e multi‑sede. Qui controlli performance e previsioni."
        }
      },
      ctas: {
        crm: "Guarda il CRM in azione",
        calendar: "Scopri la gestione appuntamenti",
        reports: "Visualizza i report reali",
        adv: "Guarda le campagne attive"
      },
      kpis: {
        messagesWeek: "Messaggi ricevuti questa settimana",
        autoReplies: "Risposte automatiche inviate",
        contactsSaved: "Contatti salvati nel CRM"
      },
      followup: {
        title: "Tasso di risposta automatica WhatsApp",
        note: "Aggiornato settimanalmente — obiettivo ≥ 85%"
      },
      ctaFinal: {
        title: "Vuoi un sistema come questo nella tua azienda?",
        button: "Prenota il Check-up gratuito"
      },
      launch: {
        formTitle: "Contatta",
        name: "Nome",
        phone: "Telefono",
        service: "Servizio",
        message: "Messaggio",
        cta: "Richiedi preventivo"
      },
      grow: {
        formTitle: "Prenota Appuntamento",
        name: "Nome",
        phone: "Telefono",
        date: "Data/Orario",
        cta: "Conferma appuntamento"
      },
      dominate: {
        formTitle: "Richiesta Analisi",
        name: "Nome",
        phone: "Telefono",
        location: "Sede",
        cta: "Avvia analisi"
      }
    },
    why: {
      bullets: [
        "Velocità = clienti: chi risponde entro 60 secondi converte di più",
        "Zero sprechi: ogni contatto finisce in un elenco ordinato",
        "Ogni mese migliori: report semplice con cosa tenere e cosa cambiare",
        "Garanzia scritta: obiettivi concordati → se non li raggiungiamo, mese dopo gratis",
      ],
    },
    ctaMid: {
      title: "Scopri cosa possiamo fare nel tuo settore",
      copy:
        "30 minuti di check-up gratuito: vediamo volumi di ricerca nella tua zona, stato del tuo profilo Google e del sito, e fissiamo obiettivi realistici.",
      button: "Prenota il Check-up",
    },
    legal: {
      title: "Note Legali",
      ateco:
        "ATECO: 62.20.10 – Consulenza e gestione sistemi informatici. Tutto resta compatibile perché trattiamo l’integrazione tecnica dei canali di comunicazione, non marketing puro.",
      adv: "Budget ADV: escluso dal canone; il budget lo sceglie il Cliente.",
      commitment: "Impegno minimo: 3 mesi, rinnovabile mese per mese.",
      credits: "Crediti operativi: ore o task inclusi nel piano; extra su preventivo.",
      gdpr: "Dati e GDPR: tutti i dati restano in UE; il Cliente ne è proprietario.",
      guarantee:
        "Garanzia: obiettivi concordati nel check-up iniziale. Se non li rispettiamo, il mese successivo è gratuito.",
    },
    credits: {
      title: "🧰 Crediti Operativi IT inclusi",
      body:
        "Ore di amministrazione mensili utilizzabili per aggiornamenti, manutenzione, gestione social o assistenza tecnica di base. Se non servono modifiche al sito, le ore vengono impiegate come help desk remoto.",
      brochure: {
        heading: "🧰 Crediti Operativi IT",
        intro:
          "Ogni piano include un monte ore mensile di amministrazione e supporto IT, utilizzabile in modo flessibile secondo le esigenze del periodo.",
        what: "Cosa puoi far rientrare in queste ore:",
        items: [
          "Aggiornamenti o modifiche al sito (testi, immagini, sezioni)",
          "Aggiornamenti tecnici e patch di sicurezza",
          "Configurazioni o risoluzione problemi su email, DNS, dominio, hosting",
          "Supporto WhatsApp Business e CRM (contatti, filtri, report)",
          "Creazione o aggiornamento post social programmati",
          "Assistenza remota via videochiamata o ticket per problemi operativi",
        ],
        practical:
          "In pratica: se in un mese non ci sono modifiche al sito o ai social, le ore vengono utilizzate come help desk informatico di base, senza costi aggiuntivi.",
        reporting:
          "Tutte le attività vengono registrate in un mini-report mensile con tempo utilizzato e interventi eseguiti.",
      },
      adminLogic: {
        title: "🧮 Logica amministrativa per piano",
        headers: ["Piano", "Ore incluse/mese", "Tipiche attività coperte"],
        rows: [
          ["Launch", "5 h", "Aggiornamenti sito, supporto WhatsApp, piccole assistenze tecniche"],
          ["Grow", "8 h", "Gestione CRM + social + manutenzione tecnica"],
          ["Dominate", "12 h", "Report BI, integrazioni, help desk multi-utente"],
        ],
      },
      compliance: {
        title: "🔐 Allineamento Legale & Fiscale (ATECO 62.20.10)",
        text:
          "Rientra in ‘installazione del sistema, formazione e assistenza agli utenti del sistema informatico’: non vendiamo esecuzione marketing, ma gestione continuativa di un sistema IT che include canali di comunicazione.",
      },
    },
    faq: {
      items: [
        { q: "Il budget pubblicitario è incluso?", a: "No. La spesa ADV è a carico del Cliente. Dal piano GROW in su gestiamo setup e ottimizzazione delle campagne." },
        { q: "Quanti lead posso aspettare?", a: "Dipende da settore e città. Nel check-up stimiamo una forchetta basata su ricerche locali e concorrenza, poi mettiamo gli obiettivi per iscritto." },
        { q: "Chi possiede i dati?", a: "Tu. I dati restano in UE, esportabili in qualsiasi momento." },
        { q: "Posso cancellare il servizio?", a: "Sì, dopo i primi 3 mesi puoi cancellare con 30 giorni di preavviso." },
        { q: "Serve che io risponda ai clienti?", a: "Con Launch ricevi contatti e puoi richiamare tu. Con Grow e Dominate l’agenda si riempie in automatico." },
      ],
    },
    method: {
      items: [
        { title: "Settimana 1", text: "Raccolta materiali, impostazione dominio, profilo Google, WhatsApp, copy del sito" },
        { title: "Settimana 2", text: "Pubblicazione sito, attivazione automazioni WhatsApp e CRM, test e consegna" },
        { title: "Da GROW", text: "Attivazione calendario automatico e campagne ADV entro 7–10 giorni dalla firma" },
      ],
    },
    ctaFinal: {
      title: "Vuoi un sistema che lavora mentre tu sei sul campo?",
      copy:
        "Prenota un check-up gratuito di 30 minuti: analizziamo le ricerche nella tua zona, il tuo profilo Google e fissiamo obiettivi misurabili.",
      button: "Prenota il Check-up",
    },
  },
  en: {
    anchors: {
      hero: "Hero",
      overview: "Overview",
      promise: "Promise",
      novita: "2025 Update",
      plans: "Plans",
      value: "Value",
      stack: "Tech Stack",
      how: "How it works",
      why: "Why it works",
      ctaMid: "Check-up",
      faq: "FAQ",
      method: "Timeline",
      legal: "Legal",
      ctaFinal: "Final CTA",
    },
    value: {
      title: "Executive Value",
      systemic: {
        title: "Systemic understanding",
        items: [
          "Visibility: Google / social",
          "Responsiveness: WhatsApp automation",
          "Lead tracking: CRM + Supabase",
          "Scheduling: Bookings / Calendly",
          "Measurement: Dashboards / BI",
          "Continuous optimization: Audit + AI"
        ],
        subtitle: "What improves are internal KPIs — speed, consistency, visibility, data ownership, predictability."
      },
      impact: {
        title: "KPI & Impact map",
        headers: ["Dimension", "KPI", "Before (SME)", "After (System)", "Impact"],
        rows: [
          ["Response speed", "Avg. time to first reply", "4–12h (manual)", "< 60s (WhatsApp)", "−95% delay, +3× conversion"],
          ["Lead capture", "% contacts recorded", "40–60%", "100% in CRM", "+60% capture"],
          ["Conversion", "% → appointment", "10–15%", "25–35%", "+2–3×"],
          ["No‑show", "% missed appointments", "25–30%", "<10%", "−65%"],
          ["Follow‑up", "% recontacted <48h", "<20%", ">90% (n8n)", "+70%"],
          ["Data ownership", "% centralized data", "Fragmented", "100% in EU (Supabase)", "Compliance"],
          ["Marketing ROI", "Cost per qualified lead", "Untracked", "−30–50% vs baseline", "↓ cost"],
          ["Customer satisfaction", "Avg. Google rating", "3.8–4.0", "4.6+", "+15–20%"],
          ["Decision control", "Access to KPIs", "None", "Live dashboard", "+100% clarity"],
          ["Admin time", "Hours/week", "5–10h", "<1h", "−80–90%"],
          ["Scalability", "Replicability", "Manual", "100% replicable", "Scalable"],
        ]
      },
      clusters: {
        title: "KPI Clusters (Executive)",
        groups: [
          { title: "Acquisition", items: ["Leads/week", "Conversion to appointment (%)", "Cost per lead (CPL)", "Time‑to‑first‑contact (s)"] },
          { title: "Operations", items: ["Auto‑confirmed appointments (%)", "Missed appointments (%)", "Follow‑up rate (%)", "Lead‑to‑customer (%)"] },
          { title: "Experience", items: ["Review requests sent (%)", "Average rating", "Customer response rate (%)"] },
          { title: "System", items: ["Automation uptime (%)", "Tasks resolved within SLA (%)", "Data sync integrity (%)", "GDPR compliance rating"] },
          { title: "Growth (DOMINATE)", items: ["Forecast accuracy (%)", "Revenue per campaign (€)", "ROI per channel (%)", "Predictive scoring (AUC)"] },
        ]
      },
      exec: {
        title: "Executive Summary",
        headers: ["Area", "Key metric", "Improvement", "Driver"],
        rows: [
          ["Lead Management", "+60% more leads saved", "Automation via CRM", "Automations"],
          ["Conversion", "+220% more appointments", "Smart reminders", "Calendar + WhatsApp"],
          ["Customer Experience", "+0.8★ Google rating", "Auto review system", "Post‑service flows"],
          ["Admin Overhead", "−80% time saved", "Automations + dashboard", "Less manual work"],
          ["ROI Visibility", "+100% data traceability", "Unified BI dashboard", "Tracking + BI"],
          ["Compliance", "100% EU‑hosted data", "Azure + Supabase", "Data governance"],
        ]
      },
      narrative: {
        title: "Strategic Narrative",
        text:
          "Adopting this system turns a traditional small business into a self‑operating digital organism: every inquiry gets a reply in seconds, every contact is saved, every action is measured. It converts chaos into a pipeline — visibility → interaction → booking → data → insight — giving the owner the superpower of knowing what works, what doesn’t, and why."
      }
    },
    meta: {
      pageName: "Solutions",
      seoTitle: "The system that brings clients to your SME",
      seoDescription:
        "We reply in 60s, book appointments and measure results. Online in 14 days.",
    },
    cta: {
      book: "Book the Check-up",
    },
    hero: {
      title: "The system that brings clients to your SME, predictably",
      subtitle:
        "We answer every inquiry within 60 seconds, book appointments and measure results. Each plan includes site, CRM, automations, digital communication and support. Live in 14 days.",
      microProof: "EU infrastructure (Azure + Supabase), GDPR by design.",
    },
    novita: {
      title: "2025 Update — Integrated Digital Communication",
      atecoNote:
        "Fully compatible with ATECO 62.20.10: this is IT systems integration for digital communication, not pure marketing.",
      intro1:
        "To deliver a truly complete online presence, every system now includes technical, automated management of social channels.",
      intro2:
        "This feature is part of IT consulting (ATECO 62.20.10) and connects your communication channels to your IT infrastructure.",
      includesTitle: "What’s included:",
      includes: [
        "Creation and configuration of Facebook, Instagram and WhatsApp Business profiles",
        "Direct connection between website, CRM and social channels",
        "Automated post publishing and scheduling (via integrated tools)",
        "Technical setup and management of Meta Ads and Google Ads (ad spend excluded)",
        "Unified dashboard monitoring (Supabase + GA4 + Meta Pixel)",
        "Monthly report with reach, contacts and response rate",
      ],
      finalitaTitle: "Purpose:",
      finalitaText:
        "Turn social channels into an extension of your company’s information system — measurable, trackable and automated.",
    },
    promise: {
      headline:
        "We build a simple client flow: people find you, get an instant reply, leave details and book. You see everything in a clear dashboard and know where clients come from.",
      guaranteeTitle: "Guarantee",
      guarantee:
        "We define realistic goals for your sector/city. If in a month we don’t hit them, the next month is free.",
    },
    overview: {
      title: "Plans overview",
      viewPlan: "View plan",
      clientFlowTitle: "Client Flow"
    },
    plans: {
      outcomesTitle: "Outcomes",
      includesTitle: "Included technical components",
      automationsTitle: "Automations (n8n)",
      goalTitle: "Goal",
      adminTitle: "Included admin hours",
      items: [
        {
          code: "launch",
          name: "LAUNCH — Autonomous Digital Presence",
          price: "€390/mo",
          for: "SMEs and professionals who want to be found and capture every lead without wasting time.",
          goal: "Be online in 14 days, reply instantly on WhatsApp and never miss a lead.",
          adminHours: "5 hours/month",
          outcomes: [
            "Online in 14 days",
            "24/7 auto-replies on website and WhatsApp",
            "All contacts saved in a simple contact list",
          ],
          includes: [
            "Fast, clear showcase site with WhatsApp/Form buttons",
            "Google Business profile: initial optimization (categories, services, photos, messages)",
            "Auto-reply to inquiries: we ask name, need and area → you’re alerted instantly",
            "Contacts list (CRM Lite) with notes and status (New / In progress / Closed)",
            "Review reminders after jobs",
            "Monthly report: requests received, performing channels, recommended actions",
            "Support: 48h response",
            "Timeline: live in 14 days. Needed: logo/photos, services, hours, service areas, WhatsApp",
          ],
          commsTitle: "Digital Communication Update",
          comms: [
            "Create and connect Facebook and Instagram profiles",
            "Integrate WhatsApp Business with site and CRM",
          ],
          shortBullets: [
            "Live in 14 days",
            "24/7 replies",
            "Contacts saved",
            "Optimized Google Business",
            "Auto reviews",
            "Monthly report",
          ],
          automations: [
            "Incoming messages → automatically saved to CRM.",
            "Instant notification via email/WhatsApp/Telegram to the owner.",
            "Auto reminders if the client does not reply within 15 min / 24h.",
          ],
        },
        {
          code: "grow",
          name: "GROW — Automated Client Acquisition",
          price: "€850/mo",
          for: "Companies that want more appointments and a sales process that runs by itself.",
          goal: "More booked appointments, fewer no-shows, clarity on numbers and full tracking.",
          adminHours: "8 hours/month",
          outcomes: [
            "More WhatsApp-booked appointments",
            "Fewer no-shows thanks to smart reminders",
            "Clarity on numbers: contact/appointment cost and MoM results",
          ],
          includes: [
            "Automated scheduling: we propose times, book and send confirmations via WhatsApp",
            "Conversation recovery: automatic follow-up when messages are left unanswered",
            "Campaign management: setup + optimization for 2 Google/Meta campaigns (ad spend excluded)",
            "Serious tracking: know each contact’s source and what converts",
            "Full pipeline: lead stages, reminders, sales notes",
            "Support: 24h response",
            "Results guarantee: goals agreed in the check-up; if we miss them, next month is free",
          ],
          commsTitle: "Advanced Digital Communication",
          comms: [
            "Automatic social post scheduling with provided design templates",
            "Technical management of ad campaigns (Meta / Google)",
            "Lead tracking from social",
          ],
          shortBullets: [
            "Auto scheduling",
            "Conversation recovery",
            "2 campaigns managed (ad spend excluded)",
            "Full pipeline",
            "Serious tracking",
            "Goal-based reporting",
            "Guaranteed results",
          ],
          automations: [
            "WhatsApp messages → CRM → Microsoft Bookings.",
            "Automatic WhatsApp reminders 2h before appointments.",
            "Post-appointment follow-up with review request.",
          ],
        },
        {
          code: "dominate",
          name: "DOMINATE — Predictive Intelligence & Total Scale",
          price: "€1,400/mo",
          for: "Multi-location/high-volume companies seeking forecasts, control and scalability.",
          goal: "Manage multi-channel client flows, forecast demand and optimize decisions with advanced dashboards.",
          adminHours: "12 hours/month",
          outcomes: [
            "KPI dashboard (estimated revenue, contact cost, appointment cost, margins)",
            "Demand and workload forecasts",
            "Advanced automations and ERP integrations",
          ],
          includes: [
            "BI dashboards with key indicators and MoM comparisons",
            "Predictions on best times/channels and no-show risk",
            "Multi-location with dedicated store reports",
            "ERP/invoicing integrations (where available)",
            "Priority interventions and quarterly mini-audits",
            "Support: 12h SLA",
          ],
          commsTitle: "Advanced Digital Communication",
          comms: [
            "BI dashboard with Google Ads, Meta Ads and CRM data",
            "Predictive analysis of advertising performance",
            "Quarterly review of digital communication strategy",
          ],
          shortBullets: [
            "KPI dashboards & forecasts",
            "Multi-location",
            "ERP integrations",
            "Quarterly audits",
            "Priority interventions",
            "12h SLA",
          ],
          automations: [
            "Multi-client data collection → predictive models → updated dashboard.",
            "Automatic notifications when defined KPIs are exceeded or fall below thresholds.",
          ],
        },
      ],
    },
    stack: {
      title: "Tech Stack",
      items: [
        "Frontend: React + Vite",
        "Backend: Supabase (DB, Auth, Storage)",
        "Automations: n8n (Azure VM or Cloud)",
        "Hosting: Azure App Service / Static Web Apps",
        "Tracking: GA4, Tag Manager, Meta Pixel",
        "Messaging: WhatsApp Business (Client account)",
      ],
    },
    how: {
      steps: [
        { title: "Be found", text: "Google Business + clear site, WhatsApp prominent" },
        { title: "Reply instantly", text: "24/7 auto-message collects need, name and area" },
        { title: "Book (from GROW)", text: "We propose times and book appointments" },
        { title: "Measure", text: "See contacts, appointments, reviews and top channels" },
      ],
    },
    diagram: {
      common: {
        inputs: {
          website: "Website",
          whatsapp: "WhatsApp",
          ads: "Google/Meta Ads",
        },
      },
      launch: {
        title: "WhatsApp Automation",
        bullets: ["Qualification", "24/7 replies", "Notifications"],
        outputs: {
          crm: "CRM Lite",
        },
      },
      grow: {
        title: "Automation → Appointment",
        bullets: ["Auto scheduling", "Reminders", "Follow-up"],
        outputs: {
          calendar: "Calendar",
          crm: "Full CRM",
        },
      },
      dominate: {
        title: "Automations + Predictive",
        bullets: ["Integrations", "AI models", "KPI alerts"],
        outputs: {
          bi: "BI Dashboard",
          crm: "CRM",
          integrations: "ERP/CRM",
        },
      },
    },
    preview: {
      common: {
        headerBrand: "Victor Lazari",
        nav: {
          home: "Home",
          leads: "Leads",
          whatsapp: "WhatsApp",
          reports: "Reports",
          settings: "Settings"
        },
        filters: {
          whatsapp: "WhatsApp",
          status: "Status",
          statusInProgress: "In progress"
        },
        panels: {
          crm: "CRM",
          calendar: "Calendar",
          adv: "Ad Campaigns"
        },
        table: {
          name: "Name",
          phone: "Phone",
          channel: "Channel",
          status: "Status",
          last: "Last activity",
          location: "Location"
        },
        widgets: {
          total: "Contacts this month",
          avgResponse: "Avg. response time",
          followup: "WhatsApp follow‑up rate",
          trend: "Weekly trend",
          revenue: "Estimated revenue",
          channelMix: "Channel mix",
          funnel: "Funnel",
          leads: "Leads",
          appointments: "Appointments",
          conversion: "Conversion",
          byLocation: "By location"
        },
        actions: {
          newLead: "New lead",
          export: "Export",
          calendar: "Calendar",
          location: "Location",
          adv: "ADV"
        },
        daysShort: ["M", "T", "W", "T", "F", "S", "S"],
        campaigns: {
          title: "Campaigns",
          budget: "Daily budget",
          cpa: "CPA",
          leads: "Leads this month",
          status: {
            active: "Active",
            paused: "Paused"
          }
        },
        notif: "Notifications",
        toast: "New WhatsApp lead saved to CRM",
        powered: "Powered by Supabase + Azure"
        ,
        rows: [
          { name: "Julia R.", phone: "+1 415 223 8821", channel: "WhatsApp", status: { code: "in_progress", label: "In progress" }, last: "5 min ago" },
          { name: "Andrew C.", phone: "+1 646 555 0342", channel: "Web Form", status: { code: "new", label: "New" }, last: "14 min ago" },
          { name: "Morelli Auto Shop", phone: "+1 305 447 9012", channel: "Google Ads", status: { code: "closed", label: "Closed" }, last: "yesterday" }
        ]
      },
      header: {
        launch: "Live system — LAUNCH plan: automated contact & messaging (Supabase + Azure)",
        grow: "Live system — GROW plan: auto‑scheduling and managed campaigns (Supabase + Azure)",
        dominate: "Live system — DOMINATE plan: BI, multi‑location and predictive (Supabase + Azure)"
      },
      demoIntro: {
        title: "Live demo — Automated contact management (integrated CRM)",
        body:
          "This is the system dashboard: messages from website, WhatsApp and Google are collected here in real time. From here you can view, reply and measure monthly performance.",
        bodyByTier: {
          launch: "This is the dashboard included in the LAUNCH plan: messages from website, WhatsApp and Google are collected here in real time. From here you can view, reply and measure monthly performance.",
          grow: "This is the dashboard for the GROW plan: messages from website/WhatsApp/Google with auto‑scheduling and CRM. Manage appointments, conversations and results here.",
          dominate: "This is the dashboard for the DOMINATE plan: messages, calendar and KPIs with BI and multi‑location. Control performance and forecasts here."
        }
      },
      ctas: {
        crm: "See the CRM in action",
        calendar: "Explore appointment management",
        reports: "View real reports",
        adv: "See active campaigns"
      },
      kpis: {
        messagesWeek: "Messages received this week",
        autoReplies: "Auto replies sent",
        contactsSaved: "Contacts saved to CRM"
      },
      followup: {
        title: "WhatsApp auto‑reply rate",
        note: "Updated weekly — target ≥ 85%"
      },
      ctaFinal: {
        title: "Want a system like this for your company?",
        button: "Book the free Check‑up"
      },
      launch: {
        formTitle: "Contact",
        name: "Name",
        phone: "Phone",
        service: "Service",
        message: "Message",
        cta: "Request quote"
      },
      grow: {
        formTitle: "Book Appointment",
        name: "Name",
        phone: "Phone",
        date: "Date/Time",
        cta: "Confirm appointment"
      },
      dominate: {
        formTitle: "Request Analysis",
        name: "Name",
        phone: "Phone",
        location: "Location",
        cta: "Run analysis"
      }
    },
    why: {
      bullets: [
        "Speed = clients: replies within 60 seconds convert more",
        "Zero waste: every contact lands in an ordered list",
        "Improve monthly: simple report on what to keep and change",
        "Written guarantee: agreed goals → if missed, next month free",
      ],
    },
    ctaMid: {
      title: "See what's possible in your sector",
      copy:
        "30-minute free check-up: local search volumes, Google profile and site status, and realistic goals.",
      button: "Book the Check-up",
    },
    legal: {
      title: "Legal Notes",
      ateco:
        "ATECO: 62.20.10 – IT consulting and systems management. Compatible because this is technical integration of communication channels, not pure marketing.",
      adv: "Ad spend: excluded from fee; Client chooses budget.",
      commitment: "Minimum term: 3 months.",
      credits: "Operational credits: monthly activities included; extra via quote.",
      gdpr: "Data & GDPR: hosted in EU, Client owns data; access logs and policies maintained.",
      guarantee:
        "Guarantee: goals agreed in the initial check-up. If we miss them, next month is free.",
    },
    credits: {
      title: "🧰 Included IT Operational Credits",
      body:
        "Monthly admin hours that can be used for updates, maintenance, social management or basic tech assistance. If no website changes are needed, hours are used as remote help desk.",
      brochure: {
        heading: "🧰 IT Operational Credits",
        intro:
          "Each plan includes a monthly allocation of admin/support hours, used flexibly based on current needs.",
        what: "Covered activities include:",
        items: [
          "Website updates (copy, images, sections)",
          "Technical updates and security patches",
          "Email/DNS/domain/hosting configuration or troubleshooting",
          "WhatsApp Business and CRM support (contacts, filters, reports)",
          "Creating/updating scheduled social posts",
          "Remote assistance via video call or ticket for operational issues",
        ],
        practical:
          "In practice: if no site/social updates are needed in a month, hours are used as basic IT help desk at no extra cost.",
        reporting:
          "All activities are logged in a monthly mini-report with time used and actions taken.",
      },
      adminLogic: {
        title: "🧮 Administrative logic per tier",
        headers: ["Plan", "Included hours/month", "Typical covered activities"],
        rows: [
          ["Launch", "5 h", "Site updates, WhatsApp support, small technical assistance"],
          ["Grow", "8 h", "CRM + social management + technical maintenance"],
          ["Dominate", "12 h", "BI reports, integrations, multi-user help desk"],
        ],
      },
      compliance: {
        title: "🔐 Legal & Fiscal Alignment (ATECO 62.20.10)",
        text:
          "This fits under ‘installation of the system, user training and assistance of the IT system’: you’re managing an IT system that includes communication channels, not selling marketing execution.",
      },
    },
    faq: {
      items: [
        { q: "Is ad budget included?", a: "No. Ad spend is paid by the Client. From GROW we manage setup and optimization." },
        { q: "How many leads can I expect?", a: "Depends on sector and city. In the check-up we estimate a range from local searches and competition, then set written goals." },
        { q: "Who owns the data?", a: "You do. Data stays in the EU and is exportable anytime." },
        { q: "Can I cancel?", a: "Yes, after the first 3 months you can cancel with 30 days' notice." },
        { q: "Do I need to reply to clients?", a: "With Launch you receive contacts and can call back. With Grow/Dominate the calendar fills automatically." },
      ],
    },
    method: {
      items: [
        { title: "Week 1", text: "Materials, copy, Google Business, site structure" },
        { title: "Week 2", text: "Go-live, enable auto-replies and reporting" },
        { title: "From GROW", text: "Auto-scheduling and campaigns live within 7–10 days of signup" },
      ],
    },
    ctaFinal: {
      title: "Want a system that works when you can’t?",
      copy:
        "Book the free check-up: in 30 minutes we understand needs, set goals and give you a clear plan.",
      button: "Book the Check-up",
    },
  },
};

